export function ConflictBanner({ onReload, onDismiss }: { onReload: () => void; onDismiss: () => void }) {
  return (
    <div className="rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <p>This item was updated elsewhere. Discard your changes and reload?</p>
      <div className="mt-2 flex gap-2">
        <button type="button" onClick={onReload} className="rounded bg-amber-600 px-2 py-1 text-xs text-white">
          Reload
        </button>
        <button type="button" onClick={onDismiss} className="rounded border border-amber-400 px-2 py-1 text-xs text-amber-900">
          Keep editing
        </button>
      </div>
    </div>
  );
}
